function Serch(ruta, obj) {
    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        }
    });
    const valor = obj.currentTarget.value;
    return new Promise(resolve => {
        $.ajax({
            url: ruta,
            method: "POST",
            data: { id: valor },
            success: function(data) {
                resolve(data);
            },
            error: function(e) {
                console.error(e);
            }
        });
    });
}

$(".autocomplete").keyup(function(obj) {
    if (obj.currentTarget.value != "") {
        let instance = M.Autocomplete.getInstance($(".autocomplete")[0]);
        instance.updateData({
            "...": null
        });
        const respnse = Serch(`${https}serchInput`, obj);
        respnse.then(data => {
            instance.updateData(data);
            instance.open();
        });
    }
});

$(".autocomplete").change(function(obj) {
    let instance = M.Autocomplete.getInstance(obj.currentTarget);
    instance.updateData({
        "...": null
    });
});

$(document).ready(function() {
    $("input.autocomplete").autocomplete({
        data: {
            "...": null
        }
    });
});
